export const lightTheme = {
  body: "white",
  text: "black",
  navLinkActive: "rgb(204, 51, 5)",
  anchor: "black",
  anchorHover: "black",
  breadCrumb: "rgb(240, 240, 240)",
  breadCrumbActive: "#0091ff",
  jumboTronBackground: "#ffec3d",
  footerBackground: "#ffec3d",
  footerColor: "black",
  btnBackgroundColor: "orange",
  btnColor: "black",
  cardBackGround: "white",
  cardImgOverlay: "orange",
  btnToggler: "rgb(204, 51, 5)",
  linkHoverColor: "#0091ff",
  linkActiveColor: "#0091ff",
  navBarBgColor: "#ffd11a",
  name: "light",
};

export const darkTheme = {
  body: "rgba(0, 10, 2, 0.7)",
  text: "greenyellow",
  toggleBorder: "#6B8096",
  navLinkActive: "white",
  anchor: "greenyellow",
  anchorHover: "white",
  breadCrumb: "rgba(0, 10, 2, 0.7)",
  breadCrumbActive: "white",
  jumboTronBackground: "rgba(0, 10, 2, 0.7)",
  jumboTronColor: "greenyellow",
  footerBackground: "rgba(0, 10, 2, 0.7)",
  footerColor: "greenyellow",
  addressColor: "greenyellow",
  btnBackgroundColor: "greenyellow",
  btnColor: "black",
  cardBackGround: "rgba(0, 10, 2, 0.7) !important;",
  cardImgOverlay: "greenyellow;",
  btnToggler: "",
  modalBackground: "rgba(0, 10, 2, 0.7)",
  modalColor: "greenyellow",
  linkHoverColor: "yellow",
  linkActiveColor: "yellow",
  name: "dark",
};
